import React from 'react';
import useSharedStyles from './use-styles';

const ExportTitle = props => {
  const {
    classes: classesProp,
    titleText,
    titleSubtext
  } = props;
  const sharedClasses = useSharedStyles(classesProp);
  return /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.customTitleRoot
  }, /*#__PURE__*/React.createElement("b", null, titleText), " ", /*#__PURE__*/React.createElement("span", {
    className: sharedClasses.customTitleDate
  }, titleSubtext));
};

export default ExportTitle;